import { defineMeta } from '@/registry/types';

export const breadcrumbsMeta = defineMeta({
  name: 'Breadcrumbs',
  level: 'molecule',
  category: 'navigation',
  classification: 'themed-mui',
  description: 'Shows the user location within a hierarchy. Themed MUI Breadcrumbs.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Breadcrumbs',
  muiDocs: 'https://mui.com/material-ui/react-breadcrumbs/',
  a2uiEquivalent: 'Breadcrumbs',
  importPath: '@/molecules/Breadcrumbs',
  optionalProps: ['separator', 'maxItems'],
  supportedStates: ['default', 'collapsed'],
  designTokens: ['colors', 'typography'],
  accessibility: [
    'Set aria-label="breadcrumb"; mark the current page as Typography (not a link) so it is not announced as a destination.',
  ],
  usageExamples: [
    '<Breadcrumbs aria-label="breadcrumb"><Link href="/assets">Assets</Link><Typography variant="body1">Finding 4821</Typography></Breadcrumbs>',
  ],
  rules: ['The current page is `Typography variant="body1"`, never a `Link`.'],
  antiPatterns: ['Do not use for primary navigation.'],
  llmSafe: true,
  whenToUse: ['Deep hierarchical pages (detail views)'],
  whenNotToUse: ['Flat apps with shallow navigation'],
});

export default breadcrumbsMeta;
